/**
 * Contractor login passwords: digits only (matches Cloud Functions policy).
 */

export const USER_DIGIT_PASSWORD_MIN_LEN = 4;
export const USER_DIGIT_PASSWORD_MAX_LEN = 20;

/** Tailwind + WebKit: numeric-style entry with disc masking where supported */
export const digitPasswordMaskClass = '[-webkit-text-security:disc]';

export function sanitizeDigitPasswordInput(raw: string): string {
  return raw.replace(/\D/g, '').slice(0, USER_DIGIT_PASSWORD_MAX_LEN);
}

export function isValidDigitPassword(value: string): boolean {
  if (value.length < USER_DIGIT_PASSWORD_MIN_LEN || value.length > USER_DIGIT_PASSWORD_MAX_LEN) {
    return false;
  }
  return /^\d+$/.test(value);
}
